'use client';

import { useEffect } from 'react';
import {
    setActiveNavCategory,
    clearActiveNavCategory,
} from '@/lib/navActiveCategory';

/**
 * Renders nothing. Publishes the current article's category slug so the header
 * nav can highlight the parent section on /news/{id}/{slug}.
 *
 * Pass an already-normalised slug (normalizeCategorySlug), because
 * articles.category stores display names like "Bangladesh" and "War Crimes",
 * not slugs. An empty slug, a blocked section or one absent from the nav lists
 * simply highlights nothing.
 */
export default function NavCategoryReporter({ category }: { category: string }) {
    useEffect(() => {
        if (!category) return;
        setActiveNavCategory(category);
        return () => clearActiveNavCategory(category);
    }, [category]);

    return null;
}